import { createSelector, createEntityAdapter } from '@reduxjs/toolkit';
import { apiSlice } from './apiSlice';

const activityAdapter = createEntityAdapter({
  selectId: (e) => e.activity_id,
});

const initialState = activityAdapter.getInitialState();

export const activityApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getActivity: builder.query({
      query: (activityId) => ({
        url: `/activity?id=${activityId}`,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
    }),
    createActivity: builder.mutation({
      query: (activityDetails) => ({
        url: `/activity`,
        method: 'POST',
        body: activityDetails,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
      invalidatesTags: ['User'],
    }),
    createCheckin: builder.mutation({
      query: (checkinDetails) => ({
        url: `/activity/checkin`,
        method: 'POST',
        body: checkinDetails,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
      invalidatesTags: ['User'],
    }),
    closeActivity: builder.mutation({
      query: (closeDetails) => ({
        url: `/activity/close`,
        method: 'PATCH',
        body: closeDetails,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
      invalidatesTags: ['User'],
    }),
    getActivityComments: builder.query({
      query: (activityId) => ({
        url: `/activity/comment?activity_id=${activityId}`,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
      provideTags: (result, error, activityId) => [
        { type: 'ActivityComment', id: activityId },
      ],
    }),
    createActivityComment: builder.mutation({
      query: (commentDetails) => ({
        url: `/activity/comment`,
        method: 'POST',
        body: commentDetails,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
      invalidatesTags: [
        { type: 'ActivityComment', id: (arg) => arg.activity_id },
      ],
    }),
    getActivityContacts: builder.query({
      query: (activityId) => ({
        url: `/activity/contact?activity_id=${activityId}`,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
      provideTags: (result, error, activityId) => [
        { type: 'ActivityContact', id: activityId },
      ],
    }),
    createActivityContact: builder.mutation({
      query: (contactDetails) => ({
        url: `/activity/contact`,
        method: 'POST',
        body: contactDetails,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
      invalidatesTags: [
        { type: 'ActivityContact', id: (arg) => arg.activity_id },
      ],
    }),
  }),
});

export const {
  useGetActivityQuery,
  useCreateActivityMutation,
  useCreateCheckinMutation,
  useCloseActivityMutation,
  useGetActivityCommentsQuery,
  useCreateActivityCommentMutation,
  useGetActivityContactsQuery,
  useCreateActivityContactMutation,
} = activityApiSlice;
